import api from '@/helpers/api'


const API_READ=`/api/systemlogs/`


export default {
  namespaced:true,
  state: {
    status: '',
    systemLogs:[],
    meta:{
      page:1,
      limit:10,
      total:1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { systemLogs }) {
      state.systemLogs = [... systemLogs]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    reset_meta(state) {
      state.meta = {
          limit: 10,
          page: 1,
          total: 1,
      }
    }
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta } = state
      const { filter } = state
      const { search } = state

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, filter, search })
          .then((response) => {
            const systemLogs = response.data.data;

            commit('read', { systemLogs })
            commit('success')
              
            commit('switch_page', { meta: { ...response.data.meta } })
            return resolve(systemLogs)
          }).catch((err) => {
            commit('error')
            return reject(err)
          }).finally(() => {
          });
      })
    }
  },
  getters: {
    systemLogs: () => state => state.systemLogs,
  }
}